import store from 'redux/store';
import { ActivityKey } from 'redux/schemas/models/activity';
import { ComponentKey } from 'redux/schemas/models/lecture-component';
import { setActivityProgress } from 'redux/actions/lecture-components';

/* @ngInject */
export default function TimelineInPersonEventLectureComponentModelService(

  _,
  nvUtil,
  $translate,
  moment,
) {
  const TimelineInPersonEventLectureComponentModel = function (attributes) {
    const _this = this;
    const base = {
      templateUrl: 'timelines/templates/nv-timeline-in-person-event.html',
    };

    /** Setting Up Basic Attributes * */
    _.extend(_this, base, attributes);

    // Ensure inPersonEvent exists
    if (!_this.inPersonEvent) {
      _this.inPersonEvent = {};
    }

    // passed lecturePage, lectureSection, course
    preprocess();

    /** Public Functions * */
    _.extend(_this, {
      getStatus,
      isCompleted,
      isMissed,
      isTodoRequiredForCompletion,
      updateComponentPointsAndProgress,
      updateComponentProgress,
      getActivityTime,
      getPayload,
    });

    /** Function Declarations * */
    /* Used Publicly */
    function getStatus() {
      return _this.inPersonEvent?.progress;
    }

    function isCompleted() {
      if (_this.inPersonEvent.isTodo && !_this.inPersonEvent.progress) {
        return _this.inPersonEvent.pointsReceived >= _this.inPersonEvent.totalPoints?.[0];
      }
      return _this.inPersonEvent.progress && (_this.inPersonEvent.progress === 'completed');
    }

    function isMissed() {
      return _this.inPersonEvent.progress === 'missed';
    }

    function isTodoRequiredForCompletion() {
      return _this.inPersonEvent.isRequiredForCompletion;
    }

    function updateComponentPointsAndProgress(componentType, componentId, pointsReceived, totalPoints, progress) {
      if ((_this.type === componentType && _this.id === componentId)
        || (componentType === ComponentKey.IN_PERSON_EVENT && _this.inPersonEvent.id === componentId)) {
        _this.inPersonEvent.progress = progress || 'completed';

        store.dispatch(setActivityProgress({
          pointsReceived,
          progress: _this.inPersonEvent.progress,
          activityKey: ActivityKey.IN_PERSON_EVENT,
          activityPayloadId: _this.inPersonEvent.id,
        }));

        _this.inPersonEvent.pointsReceived = pointsReceived;
        _this.pointsReceived = pointsReceived;

        if (_.isNumber(totalPoints)) {
          _this.currentTotalPoints = totalPoints;
        } else {
          _this.currentTotalPoints = nvUtil.getCurrentTotalPoints(_this.totalPoints, _this.lecturePage.releaseDate, _this.course.expiringPointsEnabled);
        }

        viewPreprocess();

        _this.lecturePage.preprocessSelfAndParentPointData();
      }
    }

    function updateComponentProgress(componentType, componentId, progress) {
      if ((_this.type === componentType && _this.id === componentId)
        || (componentType === ComponentKey.IN_PERSON_EVENT && _this.inPersonEvent.id === componentId)) {
        _this.inPersonEvent.progress = progress;

        store.dispatch(setActivityProgress({
          progress,
          activityKey: ActivityKey.IN_PERSON_EVENT,
          activityPayloadId: _this.inPersonEvent.id,
        }));

        _this.lecturePage.preprocessSelfAndParentPointData();
      }
    }

    function getActivityTime() {
      const eventSession = _this.inPersonEvent?.eventSessions?.[0];
      if (!eventSession || !eventSession?.startTime || !eventSession?.endTime) {
        return null;
      }
      const startTime = eventSession.timeZone
        ? moment.tz(eventSession.startTime, eventSession.timeZone).format('M/D/YYYY h:mmA')
        : moment(eventSession.startTime).format('M/D/YYYY h:mmA');
      const endTime = eventSession.timeZone
        ? moment.tz(eventSession.endTime, eventSession.timeZone).format('M/D/YYYY h:mmA')
        : moment(eventSession.endTime).format('M/D/YYYY h:mmA');

      return `${startTime} ${$translate.instant('LECTURE_PAGES.COMPONENTS.IN_PERSON_EVENTS.LOWERCASE_TO')} ${endTime}`;
    }

    function getPayload() {
      return _.pick(_this.inPersonEvent, ['title']);
    }

    /* Used Privately */
    function preprocess() {
      _this.isTodo = _this.inPersonEvent.isTodo;
      _this.hasStructuralIssues = _this.inPersonEvent.hasStructuralIssues;
      _this.pointsReceived = _this.inPersonEvent.pointsReceived;
      _this.totalPoints = _this.inPersonEvent.totalPoints;
      _this.activityId = _this.inPersonEvent.id;

      _this.currentTotalPoints = nvUtil.getCurrentTotalPoints(_this.totalPoints, _this.lecturePage.releaseDate, _this.course.expiringPointsEnabled);

      viewPreprocess();
    }

    function viewPreprocess() {
      if (isCompleted() || _this.pointsReceived > _this.currentTotalPoints) {
        _this.currentTotalPoints = _this.pointsReceived ? _this.pointsReceived : 0;
      }
      _this.displayTotalPointsOnly = !_this.pointsReceived && _this.currentTotalPoints;
    }
  };

  return TimelineInPersonEventLectureComponentModel;
}
